import { computed, ref, ComputedRef } from 'vue';
import { getCustomContactProperties } from '@/configs/custom-contact-properties';

export interface DropdownOption {
  value: string;
  displayLabel: string;
  isCustom?: boolean;
}

const BASE_I18N = 'automatedScenarios.actions.sending_channel.utm_config';

export function useUtmDropdownOptions(t: (key: string) => string): {
  dropdownOptions: ComputedRef<DropdownOption[]>;
  loadCustomData: () => Promise<void>;
} {
  const customDataOptions = ref<DropdownOption[]>([]);

  const baseOptions = computed<DropdownOption[]>(() => [
    { value: 'shopimind', displayLabel: t(`${BASE_I18N}.fixedShopimind`) },
    { value: '{var=campaign_name}', displayLabel: t(`${BASE_I18N}.dropdownOptions.campaign_name`) },
    { value: '{var=campaign_type}', displayLabel: t(`${BASE_I18N}.dropdownOptions.campaign_type`) },
    { value: '{var=campaign_id}', displayLabel: t(`${BASE_I18N}.dropdownOptions.campaign_id`) },
    { value: '{var=channel}', displayLabel: t(`${BASE_I18N}.dropdownOptions.channel`) },
    { value: '{var=contact.first_name}', displayLabel: t(`${BASE_I18N}.dropdownOptions.contact_firstname`) },
    { value: '{var=contact.last_name}', displayLabel: t(`${BASE_I18N}.dropdownOptions.contact_lastname`) },
    { value: '{var=contact.email}', displayLabel: t(`${BASE_I18N}.dropdownOptions.contact_email`) },
    { value: '{var=contact.gender}', displayLabel: t(`${BASE_I18N}.dropdownOptions.contact_gender`) },
    { value: '{var=contact.id_customer_shop}', displayLabel: t(`${BASE_I18N}.dropdownOptions.contact_id`) },
    { value: '{var=shop.name}', displayLabel: t(`${BASE_I18N}.dropdownOptions.shop_name`) },
  ]);

  const dropdownOptions = computed(() => [
    ...baseOptions.value,
    ...customDataOptions.value,
  ]);

  const loadCustomData = async () => {
    try {
      const customSchemas = await getCustomContactProperties();
      const options: DropdownOption[] = [];
      customSchemas.forEach((schema) => {
        schema.properties.forEach((prop) => {
          if (prop.variableName) {
            options.push({
              value: `{var=${prop.variableName}}`,
              displayLabel: `${schema.schemaName} - ${prop.label || prop.name}`,
              isCustom: true,
            });
          }
        });
      });
      customDataOptions.value = options;
    } catch {
      // Silently fail, custom data options won't be available
    }
  };

  return {
    dropdownOptions,
    loadCustomData,
  };
}
